/**
 * Aggregates add-on selections from all sibling `<product-addon>` elements, enforces one active
 * add-on per type, and injects the corresponding hidden cart inputs into the product form.
 */
if (!customElements.get('addons-manager')) {

  /**
   * Aggregates add-on selections from all `product-addon` elements within the
   * nearest `.product-main-element`. Listens for `addOn:added`, `addOn:removed`,
   * and `addOn:clear` events and maintains a deduplicated list of active add-ons
   * (one entry per `addOnType`).
   */
  class ComponentAddOnsManager extends HTMLElement {
    constructor() {
      super();

      this.INPUT_CLASS_ID = 'input-add-on'

      this.mainElement = this.closest('.product-main-element');
      this.addOnElemnents = this.mainElement.querySelectorAll('.product-addon');
      this.addOns = [];

      this.variantChangeHandler = this.onVariantChange.bind(this);

      this.init()
    }

    init() {
      if (this.mainElement) {
        this.mainElement.addEventListener('variantChange', this.variantChangeHandler)
      }
      this.initAddOns();
    }

    disconnectedCallback() {
      this.mnainElement?.removeEventListener('variantChange', this.variantChangeHandler)
    }

    initAddOns() {
      this.addOnElemnents.forEach(addOn => {
        addOn.addEventListener('addOn:clear', this.onAddOnClear.bind(this));
        addOn.addEventListener('addOn:added', this.onAddOnAdded.bind(this));
        addOn.addEventListener('addOn:removed', this.onAddOnRemoved.bind(this));
      });
    }

    onVariantChange(event) {
      this.onAddOnClear()
    }

    onAddOnClear() {
      this.addOns = [];
      this.renderFormData();
    }

    onAddOnAdded(event) {
      const newAddOn = event.detail;
      this.addOns = [
        ...this.addOns.filter(addOn => addOn.addOnType !== newAddOn.addOnType),
        newAddOn
      ];
      this.renderFormData();
    }

    onAddOnRemoved(event) {
      const removedAddOn = event.detail;
      this.addOns = this.addOns.filter(addOn => addOn.addOnType !== removedAddOn.addOnType);
      this.renderFormData();
    }

    clearFormData() {
      this.mainElement.querySelector('form')?.querySelectorAll(`input.${this.INPUT_CLASS_ID}`).forEach(el => el.remove())
    }

    renderFormData() {

      const form = this.mainElement.querySelector('form');
      if (!form) return;
      this.clearFormData()
      if (!this.addOns.length) return;

      const formData = [
        $s.createInput({ name: 'properties[_bundle_item]', value: 'main', styleClasses: [this.INPUT_CLASS_ID] }),
        $s.createInput({ name: 'properties[_bundle_id]', styleClasses: [this.INPUT_CLASS_ID] }),
        ...this.addOns.flatMap((addOn, indexAddOn) => [
          $s.createInput({ name: `items[${indexAddOn}][id]`, value: addOn.variant.id, styleClasses: [this.INPUT_CLASS_ID, addOn.addOnType] }),
          $s.createInput({ name: `items[${indexAddOn}][properties[_market]]`, value: addOn.market, styleClasses: [this.INPUT_CLASS_ID, addOn.addOnType] }),
          $s.createInput({ name: `items[${indexAddOn}][properties[_bundle_item]]`, value: addOn.bundleType, styleClasses: [this.INPUT_CLASS_ID, addOn.addOnType] }),
          $s.createInput({ name: `items[${indexAddOn}][properties[_bundle_id]]`, styleClasses: [this.INPUT_CLASS_ID, addOn.addOnType] })
        ])
      ]
      form.append(...formData.filter(item => item))
    }
  }

  customElements.define('addons-manager', ComponentAddOnsManager);
}
